const dataLay = {
	pushData: function (element, placement, event = 'contact-form-modal-show', product = undefined) {
		if (!element) {
			return;
		}
		element.addEventListener('click', function () {
			dataLayer.push({
				'event': `${event}`,
				'product': `${product}`,
				'placement': `${placement}`
			});
		})
	},
	productButton: () => {
		const openContactFormModal = document.querySelectorAll('.main-button.js-open-contact-form-modal');

		if (openContactFormModal) {
			openContactFormModal.forEach(function (el) {
				const boxButtons = el.closest('.box__buttons');
				if (boxButtons && boxButtons.previousElementSibling) {
					const productTitle = boxButtons.previousElementSibling.querySelector('.box__title');

					if (productTitle) {
						window.dataLayer = window.dataLayer || [];
						dataLay.pushData(el, 'Content', 'contact-form-modal-show', productTitle.textContent);
					}
				}
			});
		}
	},
	singleButton: function () {

		const footerButton = document.querySelector('.contact-box__link.js-open-contact-form-modal');
		const contactButton = document.querySelector('.contact-info-box.js-open-contact-form-modal');

		window.dataLayer = window.dataLayer || [];
		this.pushData(footerButton, 'Footer');
		this.pushData(contactButton, 'Contact CTA');

	},
	formEvents: function () {
		const form = document.querySelector('.js-contact-form-modal form'),
			closeForm = document.querySelector('.js-close-contact-form-modal');

		if (!form) {
			return
		}

		window.dataLayer = window.dataLayer || [];
		form.addEventListener('submit', function (e) {

			const data = Object.fromEntries(new FormData(e.target).entries());
			let formModalDate,
				formData = [];

			if (data['text-for-date']) {
				formModalDate = `${data['text-for-date']} / ${data['radio-hour']}`
			} else {
				formModalDate = 'soon';
			}

			for (const property in data) {
				if ((data[property] === 'hide' || !data[property]) && property !== '_wpcf7_posted_data_hash') {
					formData.push(`${property}`);
				}
			}
			formData = formData.join(', ')

			setTimeout(function () {
				let formControl = form.querySelectorAll('.wpcf7-not-valid');
				if (0 !== formControl.length) {
					dataLayer.push({
						'event': 'contact-form-modal-validation',
						'form-modal-validation-fields': `${formData}`,
					});
				} else {
					dataLayer.push({
						'event': 'contact-form-modal-submit',
						'form-modal-date': `${formModalDate}`,
					});
				}
			}, 1000)
		})

		closeForm.addEventListener('click', function () {
			dataLayer.push({
				'event': 'contact-form-modal-close',
			});
		})

	}

}
export default dataLay;
